import React from 'react';
import './style.scss';
import Logo from 'assets/logo_white.svg';
import { NavLink } from 'react-router-dom';
import { PagePath } from 'constants/pagePath';

export const Footer = () => {
  return (
    <>
      <footer className="footer">
        <NavLink to={PagePath.Home} className="footer_logo">
          <img src={Logo} alt="Logo" />
        </NavLink>
        <p className="footer_company">
          株式会社FPG
          <br />
          金融商品取引業者　関東財務局長（金商）第1832号
          <br />
          加入協会　一般社団法人第二種金融商品取引業協会
        </p>
        <div className="footer_help">
          <FooterHelp href="https://www.fpg.jp/commission.html" label="手数料等およびリスクについて" />
          <FooterHelp href="https://www.fpg.jp/solicitation.html" label="金融商品勧誘方針" />
          <FooterHelp href="https://www.fpg.jp/privacy.html" label="個人情報の保護に関する公表事項" />
          <FooterHelp
            href={process.env.REACT_APP_ELECTORIC_GENERAL_TERMS_CONDITION_URL ?? ''}
            label="FPGオンライン取引・電子署名取引一般規約"
          />
          <FooterHelp href="https://www.fpg.jp/otoiawase/index.html" label="苦情相談について" />
        </div>
      </footer>
    </>
  );
};

type FooterHelpProps = {
  href: string;
  label: string;
};

const FooterHelp = (props: FooterHelpProps) => {
  const { href, label } = props;
  return (
    <a href={href} className="footerHelp" target="_blank" rel="noopener noreferrer">
      {label}
    </a>
  );
};
